import axios from "axios";
import { Base_URL } from "../url";

export const fetchSalaries = async (id) => {
  try {
    const response = await axios.get(`${Base_URL}/SalaryProcess/SalaryGetData/${id}`);
    console.log(response);
    return response.data;
  } catch (error) {
    throw error.response?.data || "Error fetching salary data!";
  }
};